<template>
  <div class="w-full flex flex-1 flex-col">
    <slot />
  </div>
</template>
